module.exports = __webpack_public_path__ + "img/84.50030896.png";